import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  data: null,
};

const orderCountSlice = createSlice({
  name: "orderCount",
  initialState,
  reducers: {
    fetchOrderCount: (state, action) => {
      state.loading = true;
      state.error = null;
      state.data = null;
    },
    fetchOrderCountSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    fetchOrderCountFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { actions, reducer } = orderCountSlice;
export const sliceKey = orderCountSlice.name;
